import { businessBaseURL } from "./base";
var baseURL = businessBaseURL + "/owner";
export var owner = {
    home: function () { return baseURL; },
    playlists: {
        index: function (type) {
            return baseURL + "/playlists/" + type;
        },
        view: function (id) { return baseURL + "/playlists/public/" + id; },
        edit: function (id) { return baseURL + "/playlists/private/" + id + "/edit"; },
    },
    devices: {
        index: function () { return baseURL + "/devices"; },
        settings: function (id) { return baseURL + "/devices/" + id + "/settings"; },
    },
    timetables: {
        index: function () { return baseURL + "/timetables"; },
        edit: function (id) { return baseURL + "/timetables/" + id + "/edit"; },
    },
    schedules: {
        index: function () { return baseURL + "/schedules"; },
        edit: function (id) { return baseURL + "/schedules/" + id + "/edit"; },
    },
    programs: {
        index: function () { return baseURL + "/programs"; },
        edit: function (id) { return baseURL + "/programs/" + id + "/edit"; },
    },
    files: {
        index: function () { return baseURL + "/files"; },
    },
    details: {
        index: function () { return baseURL + "/details"; },
    },
};
